import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import type { FormRule } from 'antd';

export function usePasswordValidations(controlName?: string): FormRule[] {
    const { t } = useTranslation();

    return useMemo<FormRule[]>(
        () => [
            {
                required: true,
                message: t('requiredControlError', {
                    controlName:
                        controlName ??
                        t('passwordInputLabel', { ns: 'auth' }).toLowerCase(),
                }),
            },
            {
                pattern: /^\S{8,}$/,
                message: t('passwordMinLengthError', { ns: 'translation' }),
            },
            {
                pattern: /^\S{0,20}$/,
                message: t('passwordMaxLengthError', { ns: 'translation' }),
            },
            {
                pattern: /(?=.*[0-9])/,
                message: t('passwordOneDigitError', { ns: 'translation' }),
            },
        ],
        [t, controlName],
    );
}
